import * as React from 'react';

import BooksPaymentMethods from '../../../../components/books/model1/forms/BooksPaymentMethods';
import * as IBooks from '../../../../interfaces/merchants/resources/books';

interface Props {
  paymentMethods: IBooks.PaymentMethod[];
  selectedMethod?: IBooks.PaymentMethod['method'];
  onSelect: (paymentMethod: IBooks.PaymentMethod) => void;
  subComponents: { [m in IBooks.PaymentMethod['method']]: React.ReactNode };
}

class InputPaymentPaymentMethods extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { value },
    } = e;
    const { onSelect, paymentMethods } = this.props;
    const paymentMethod = paymentMethods.find(p => p.method === value);
    onSelect(paymentMethod!);
  }

  public render() {
    const { paymentMethods, selectedMethod, subComponents } = this.props;
    return (
      <BooksPaymentMethods
        payments={paymentMethods}
        selectedMethod={selectedMethod}
        onChange={this.handleChange}
        subComponents={subComponents}
      />
    );
  }
}

export default InputPaymentPaymentMethods;
